import {Component, Inject, Injectable, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ConfService} from '../conf.service';
import {DataService} from '../data-catalogue/er-diagram/service/data.service';
import {FlatTreeControl, NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {CollectionViewer, DataSource, SelectionChange} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {merge} from 'rxjs';
import {map} from 'rxjs/operators';
// tslint:disable-next-line:import-blacklist
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';
import {ListenerService} from '../listener.service';
import {DatabasesComponent} from '../settings/databases/databases.component';
import {KongService} from '../kong.service';
import {DatacatalogListenerService} from '../datacatalog-listener.service';
import {AccountInfoService} from '../user/account-info.service';

export class DynamicFlatNode {
    constructor(public item: string, public level = 1, public expandable = false, public icons: string,
                public dbConnectionName: '', public dbName: '', public selectedDbConnectionObject: [], public tagName: string, public dbObjectType: any, public databaseType: string,
                public resObj: any, public isLoading = false) {
    }
}

@Injectable({providedIn: 'root'})
export class DynamicDatabase {

    level1Elements = [
        {
            name: 'Databases',
            iconName: 'fa fa-database',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'connectionChild',
            dbObjectType: '',
            resObj: []
        },
        {
            name: 'Users',
            iconName: 'fa fa-users',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'connectionChild',
            dbObjectType: '',
            resObj: []
        },
        {
            name: 'Administrator',
            iconName: 'fa fa-user',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'connectionChild',
            dbObjectType: '',
            resObj: []
        },
        {
            name: 'System Info',
            iconName: 'fa fa-info',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'connectionChild',
            dbObjectType: '',
            resObj: []
        }
    ];
    level3Elements = [
        {
            name: 'Tables',
            iconName: 'fa fa-table',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'dbChild',
            dbObjectType: '',
            resObj: []
        },
        {
            name: 'Views',
            iconName: 'fa fa-eye',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'dbChild',
            dbObjectType: '',
            resObj: []
        },
        {
            name: 'Procedures',
            iconName: 'fa fa-tasks',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'dbChild',
            dbObjectType: '',
            resObj: []
        },
        {
            name: 'Triggers',
            iconName: 'fa fa-bolt',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'dbChild',
            dbObjectType: '',
            resObj: []
        },
        {
            name: 'Indexes',
            iconName: 'fa fa-calendar',
            dbConnectionName: '',
            dbName: '',
            selectedDbConnectionObject: [],
            tagName: 'dbChild',
            dbObjectType: '',
            resObj: []
        }
    ];


    selectedDatabaseConnection: any;
    databaseConnections: any;
    databaseResponse: any;
    tableResponse: any;
    viewResponse: any;
    databaseConnectionName: any;
    databaseName: any;
    tableName: any;
    expandable: number;
    erTables = [];
    relations = [];
    erDataLoading: boolean;
    databaseResponseLength: any;
    tableResponseLength: any;
    viewResponseLength: any;
    dbObjectType: any;
    indexResponse: any;
    triggerResponse: any;
    procedureResponse: any;
    indexResponseLength: any;
    triggersResponseLength: any;
    procedureResponseLength: any;
    commonResponse = {};
    listOfTables: any;

    @Input() partner = localStorage.getItem('partner');

    constructor(public confPost: ConfService, public platform: LeftpanelComponent, public router: Router, public dialog: MatDialog, public databasesResource: DatabasesComponent) {
    }

    /** Initial data from database */
    initialData(val, val2): DynamicFlatNode[] {
        this.databaseConnections = val2;
        return val2.map(db => new DynamicFlatNode(db.database_name, 0, true, 'fa fa-plug', '', '', [], 'connection', '', db.database_type, []));
    }

    get geterTables(): any {
        return this.erTables;
    }

    get getRelations(): any {
        return this.relations;
    }

    get getErDataLoadingStatus(): any {
        return this.erDataLoading;
    }

    get getTablesForDatabase(): any {
        return this.tableResponse;
    }

    addDatabaseIcon(res, iconName, dbObjectType, obj, tagName) {
        return {
            name: res,
            iconName: iconName,
            dbConnectionName: this.databaseConnectionName,
            dbName: this.databaseName,
            selectedDbConnectionObject: this.selectedDatabaseConnection,
            dbObjectType: dbObjectType,
            resObj: obj,
            tagName: tagName
        };
    }

    getChildren(parentNode: DynamicFlatNode, dynamicFlatNode: DynamicFlatNode, level: number, expand: boolean): Promise<any | undefined> {
        const node = dynamicFlatNode.item;
        this.databaseResponse = [];
        if (level === 0) {
            this.databaseConnectionName = node;
            return new Promise((resolve, reject) => {
                this.expandable = this.level1Elements.length;
                return resolve(this.level1Elements);
            });
        } else if (level === 1 && node === 'Databases') {
            this.databaseName = node;
            if (expand) {
                return new Promise((resolve, reject) => {
                    this.selectedDatabaseConnection = this.databaseConnections.filter((element) => element['database_name'] === this.databaseConnectionName);
                    if (this.selectedDatabaseConnection[0]['database_type'] !== 'csv') {
                        this.confPost.getDatabasesForAConnection(this.partner, this.selectedDatabaseConnection[0]['database_name'], this.selectedDatabaseConnection[0]['database_type']).subscribe(response => {
                            if (response) {

                                this.databaseResponse = response;
                                const temp = this.databaseResponse.map(res => this.addDatabaseIcon(res, 'fa fa-database', 'database', [], 'database'));
                                this.expandable = this.databaseResponse.length;
                                this.databaseResponseLength = this.databaseResponse.length;
                                return resolve(temp);
                            } else {
                                this.platform.openSnackBar('No Databases Present', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                return resolve(this.databaseResponse = []);
                            }
                        }, error => {
                            this.platform.openSnackBar('No Databases Present', 'Error', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.databaseResponse = [];
                            this.databaseResponseLength = 0;
                            return resolve(this.databaseResponse);
                        });
                    } else {
                        this.databaseResponse.push(this.databaseConnectionName);
                        const temp = this.databaseResponse.map(res => this.addDatabaseIcon(res, 'fa fa-database', 'database', [], 'database'));
                        resolve(temp);
                    }

                });
            } else {
                return new Promise((resolve, reject) => {
                    resolve(this.databaseResponse);
                });
            }

        } else if (level === 2) {
            this.databaseName = node;
            return new Promise((resolve, reject) => {
                this.expandable = this.level3Elements.length;
                return resolve(this.level3Elements);
            });
        } else if (level === 3 && node === 'Tables') {
            this.databaseConnectionName = parentNode.dbConnectionName;
            this.databaseName = parentNode.item;
            if (expand) {
                return new Promise((resolve, reject) => {
                    this.selectedDatabaseConnection = this.databaseConnections.filter((element) => element['database_name'] === this.databaseConnectionName);
                    this.confPost.getDatabaseTablesForAConnection(this.partner, this.selectedDatabaseConnection[0]['database_name'], this.selectedDatabaseConnection[0]['database_type'], this.databaseName).subscribe(response => {
                        if (response) {
                            this.tableResponse = response;
                            if (this.tableResponse && this.tableResponse.length) {
                                const temp = this.tableResponse.map(res => this.addDatabaseIcon(res, 'fa fa-table', 'table', res, 'tableChild'));
                                this.expandable = 0;
                                this.tableResponseLength = this.tableResponse.length;
                                resolve(temp);
                            } else {
                                this.platform.openSnackBar('No Tables Present', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.tableResponseLength = 0;
                                resolve(this.tableResponse);
                            }

                        } else {
                            this.platform.openSnackBar('No Tables Present', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.tableResponseLength = 0;
                            resolve(this.tableResponse);
                        }
                    }, error => {
                        this.tableResponseLength = 0;
                        this.databaseResponse = [];
                        this.platform.openSnackBar('No Tables Present', 'Error', {
                            duration: 3000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        resolve(this.tableResponse);
                    });
                });
            } else {
                return new Promise((resolve, reject) => {
                    resolve(this.tableResponse);
                });
            }
        } else if (level === 3 && node === 'Views') {
            this.databaseConnectionName = parentNode.dbConnectionName;
            this.databaseName = parentNode.item;
            if (expand) {
                return new Promise((resolve, reject) => {
                    this.selectedDatabaseConnection = this.databaseConnections.filter((element) => element['database_name'] === this.databaseConnectionName);
                    const payload = {
                        'databaseConnectionName': this.databaseConnectionName,
                        'databaseObjects': ['views'],
                        'databaseName': this.databaseName
                    };
                    this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                        if (response) {
                            this.viewResponse = response;
                            let temp: any;
                            if (this.viewResponse && this.viewResponse['views'] && this.viewResponse['views'].length) {
                                temp = this.viewResponse['views'].map(res => this.addDatabaseIcon(res['TABLE_NAME'], 'fa fa-eye', 'view', res, 'viewChild'));
                            } else {
                                this.platform.openSnackBar('No views Present', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                            //this.generateErDiagramForDatabase(response);
                            this.expandable = 0;
                            this.viewResponseLength = this.viewResponse.length;
                            resolve(temp);
                        } else {
                            this.platform.openSnackBar('No views Present', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.tableResponseLength = 0;
                            this.viewResponse = [];
                            resolve(this.viewResponse);
                        }
                    }, error => {
                        this.tableResponseLength = 0;
                        this.databaseResponse = [];
                        this.platform.openSnackBar('No views Present', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.viewResponse = [];
                        resolve(this.viewResponse);
                    });
                });
            } else {
                return new Promise((resolve, reject) => {
                    return resolve(this.viewResponse);
                });
            }
        } else if (level === 3 && node === 'Indexes') {
            this.databaseConnectionName = parentNode.dbConnectionName;
            this.databaseName = parentNode.item;
            if (expand) {
                return new Promise((resolve, reject) => {
                    this.selectedDatabaseConnection = this.databaseConnections.filter((element) => element['database_name'] === this.databaseConnectionName);
                    const payload = {
                        'databaseConnectionName': this.databaseConnectionName,
                        'databaseObjects': ['indexes'],
                        'databaseName': this.databaseName
                    };
                    this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                        if (response) {
                            this.indexResponse = response;
                            let ress = [];
                            let modifiedResponse = [];
                            if (this.indexResponse && this.indexResponse['indexes'] && this.indexResponse['indexes'].length) {
                                for (let index of this.indexResponse['indexes']) {
                                    let temp = {};
                                    for (const key of Object.keys(index)) {
                                        temp[key.toUpperCase()] = index[key];
                                    }
                                    modifiedResponse.push(temp);
                                }
                                for (let i = 0; i < modifiedResponse.length; i++) {
                                    if (modifiedResponse[i]['INDEX_NAME'] !== null) {
                                        ress.push(modifiedResponse[i]);
                                    }
                                }
                                const temp = ress.map(res => this.addDatabaseIcon(res['INDEX_NAME'], 'fa fa-calendar', 'indexes', res, 'indexChild'));
                                this.expandable = 0;
                                this.indexResponseLength = this.indexResponse.length;
                                resolve(temp);
                            } else {
                                this.platform.openSnackBar('No Indexess Present', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                resolve([]);
                            }
                        } else {
                            this.platform.openSnackBar('No Indexess Present', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.indexResponseLength = 0;
                            this.indexResponse = [];
                            resolve(this.indexResponse);
                        }
                    }, error => {
                        this.indexResponseLength = 0;
                        this.platform.openSnackBar('No Indexess Present', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.indexResponse = [];
                        resolve(this.indexResponse);
                    });
                });
            } else {
                return new Promise((resolve, reject) => {
                    return resolve(this.indexResponse);
                });
            }
        } else if (level === 3 && node === 'Triggers') {
            this.databaseConnectionName = parentNode.dbConnectionName;
            this.databaseName = parentNode.item;
            if (expand) {
                return new Promise((resolve, reject) => {
                    this.selectedDatabaseConnection = this.databaseConnections.filter((element) => element['database_name'] === this.databaseConnectionName);
                    const payload = {
                        'databaseConnectionName': this.databaseConnectionName,
                        'databaseObjects': ['triggers'],
                        'databaseName': this.databaseName
                    };
                    this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                        if (response) {
                            this.triggerResponse = response;
                            let temp: any;
                            if (this.triggerResponse && this.triggerResponse['triggers'] && this.triggerResponse['triggers'].length) {
                                if (this.databaseName === 'postgres') {
                                    temp = this.triggerResponse['triggers'].map(res => this.addDatabaseIcon(res['tgname'], 'fa fa-bolt', 'triggers', res, 'triggerChild'));
                                } else {
                                    temp = this.triggerResponse['triggers'].map(res => this.addDatabaseIcon(res['name'], 'fa fa-bolt', 'triggers', res, 'triggerChild'));
                                }
                                this.expandable = 0;
                                this.triggersResponseLength = this.triggerResponse.length;
                                resolve(temp);
                            } else {
                                this.platform.openSnackBar('No triggers Present', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                resolve([]);
                            }

                        } else {
                            this.platform.openSnackBar('No triggers Present', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.triggersResponseLength = 0;
                            this.triggerResponse = [];
                            resolve(this.triggerResponse);
                        }
                    }, error => {
                        this.triggersResponseLength = 0;
                        this.platform.openSnackBar('No triggers Present', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.triggerResponse = [];
                        resolve(this.triggerResponse);
                    });
                });
            } else {
                return new Promise((resolve, reject) => {
                    return resolve(this.triggerResponse);
                });
            }
        } else if (level === 3 && node === 'Procedures') {
            this.databaseConnectionName = parentNode.dbConnectionName;
            this.databaseName = parentNode.item;
            if (expand) {
                return new Promise((resolve, reject) => {
                    this.selectedDatabaseConnection = this.databaseConnections.filter((element) => element['database_name'] === this.databaseConnectionName);
                    const payload = {
                        'databaseConnectionName': this.databaseConnectionName,
                        'databaseObjects': ['procedures'],
                        'databaseName': this.databaseName
                    };
                    this.confPost.getEntireSchemaForPartnerDatabase(this.partner, payload).subscribe(response => {
                        if (response) {
                            this.procedureResponse = response;
                            let modifiedResponse = [];
                            if (this.procedureResponse && this.procedureResponse['procedures'] && this.procedureResponse['procedures'].length) {
                                for (const index of this.procedureResponse['procedures']) {
                                    let temp = {};
                                    for (const key of Object.keys(index)) {
                                        temp[key.toUpperCase()] = index[key];
                                    }
                                    modifiedResponse.push(temp);
                                }
                                const temp = modifiedResponse.map(res => this.addDatabaseIcon(res['PROCEDURE_NAME'], 'fa fa-tasks', 'procedures', res, 'proceduresChild'));
                                this.expandable = 0;
                                this.procedureResponseLength = this.procedureResponse.length;
                                resolve(temp);
                            } else {
                                this.platform.openSnackBar('No procedures Present', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                resolve([]);
                            }

                        } else {
                            this.platform.openSnackBar('No procedures Present', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.procedureResponseLength = 0;
                            this.procedureResponse = [];
                            resolve(this.procedureResponse);
                        }
                    }, error => {
                        this.procedureResponseLength = 0;
                        this.platform.openSnackBar('No procedures Present', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.procedureResponse = [];
                        resolve(this.procedureResponse);
                    });
                });
            } else {
                return new Promise((resolve, reject) => {
                    return resolve(this.procedureResponse);
                });
            }
        } else {
            return new Promise((resolve, reject) => {
                return resolve([]);
            });
        }
    }

    isExpandable(node: string): boolean {
        if (this.expandable > 0) {
            return true;
        } else {
            return false;
        }
    }
}

export class DynamicDataSource implements DataSource<DynamicFlatNode> {

    dataChange = new BehaviorSubject<DynamicFlatNode[]>([]);


    get data(): DynamicFlatNode[] {
        return this.dataChange.value;
    }

    set data(value: DynamicFlatNode[]) {
        this._treeControl.dataNodes = value;
        this.dataChange.next(value);
    }

    constructor(private _treeControl: FlatTreeControl<DynamicFlatNode>,
                private _database: DynamicDatabase) {
    }

    connect(collectionViewer: CollectionViewer): Observable<DynamicFlatNode[]> {
        this._treeControl.expansionModel.changed.subscribe(change => {
            if ((change as SelectionChange<DynamicFlatNode>).added ||
                (change as SelectionChange<DynamicFlatNode>).removed) {
                this.handleTreeControl(change as SelectionChange<DynamicFlatNode>);
            }
        });

        return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
    }

    disconnect(collectionViewer: CollectionViewer): void {
    }

    /** Handle expand/collapse behaviors */
    handleTreeControl(change: SelectionChange<DynamicFlatNode>) {
        if (change.added) {
            change.added.forEach(node => this.toggleNode(node, true));
        }
        if (change.removed) {
            change.removed.slice().reverse().forEach(node => this.toggleNode(node, false));
        }
    }

    /**
     * Toggle the node, remove from display list
     */

    getParent(node: DynamicFlatNode) {
        // const { treeControl } = this;
        const currentLevel = this._treeControl.getLevel(node);

        if (currentLevel < 1) {
            return null;
        }

        const startIndex = this._treeControl.dataNodes.indexOf(node) - 1;

        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this._treeControl.dataNodes[i];

            if (this._treeControl.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
    }

    async toggleNode(node: DynamicFlatNode, expand: boolean) {
        node.isLoading = true;
        let children = await this._database.getChildren(this.getParent(node), node, node.level, expand);
        if (children === undefined) {
            node.isLoading = false;
        }
        let index = this.data.indexOf(node);
        if (!children || index < 0) { // If no children, or cannot find the node, no op
            return;
        }
        setTimeout(() => {
            if (expand) {
                const nodes = children.map(name =>
                    new DynamicFlatNode(name['name'], node.level + 1, this._database.isExpandable(name), name['iconName'],
                        name['dbConnectionName'], name['dbName'], name['selectedDbConnectionObject'], name['tagName'], name['dbObjectType'], name['resObj'], name['database_type']));
                this.data.splice(index + 1, 0, ...nodes);
            } else {
                let count = 0;
                for (let i = index + 1; i < this.data.length
                && this.data[i].level > node.level; i++, count++) {
                }
                this.data.splice(index + 1, count);
            }

            // notify the change
            this.dataChange.next(this.data);
            node.isLoading = false;
        }, 0);
    }
}


@Component({
    selector: 'app-data-catalogue-parent',
    templateUrl: './data-catalogue-parent.component.html',
    styleUrls: ['./data-catalogue-parent.component.scss'],
})
export class DataCatalogueParentComponent implements OnInit {

    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() pkey = localStorage.getItem('partnerKey');

    databaseConnections = [];
    databaseConnectionName: any;
    selectedDatabaseConnectionObject: any;
    databaseName: string;
    tableName: string;
    databases: any;
    tables: any;

    metaSchema: any;
    foreignKeys: any;
    references: any;
    erTables = [];
    relations = [];

    selectedTables = [];
    selectedViews = [];
    databaseObjs: string[] = [];
    currentParentTab: string;
    selectedIndex = 0;


    constructor(public dialog: MatDialog,
                public confPost: ConfService,
                public dataService: DataService,
                public platform: LeftpanelComponent,
                public database: DynamicDatabase,
                public accountInfoService: AccountInfoService,
                public listenerInstance: ListenerService,
                public databasesResource: DatabasesComponent) {
        this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.isExpandable);
        this.dataSource = new DynamicDataSource(this.treeControl, database);
        listenerInstance.generateTableFromChild.subscribe((tableObject) => {
            if (tableObject) {
                this.loadTablesIntoTabs(tableObject['tableName'], tableObject['databaseConnectionName'], tableObject['databaseName'], tableObject['selectedDatabaseConnectionObject']);
            }
        });

        listenerInstance.generateObjFromChild.subscribe((dbObj) => {
            if (dbObj) {
                if (dbObj['dbType'] === 'views') {
                    this.loadViewsIntoTabs(dbObj['objName'], dbObj['databaseConnectionName'], dbObj['databaseName'], dbObj['selectedDatabaseConnectionObject'], dbObj['resObj']);
                } else {
                    this.loadObjsInTabs(dbObj['objName'], dbObj['resObj'], dbObj['selectedDatabaseConnectionObject'], dbObj['dbType']);
                }
            }
        });
    }

    treeControl: FlatTreeControl<DynamicFlatNode>;

    dataSource: DynamicDataSource;

    getLevel = (node: DynamicFlatNode) => node.level;

    isExpandable = (node: DynamicFlatNode) => node.expandable;

    hasChild = (_: number, _nodeData: DynamicFlatNode) => _nodeData.expandable;

    async ngOnInit() {
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            this.getSQLDatabases(this.platform.databases);
        } else {
            await this.platform.getDatabasesForPartnerAccount();
            if (this.platform.databases) {
                this.getSQLDatabases(this.platform.databases);
            }
        }
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
    }

    getSQLDatabases(databases) {
        for (const database of databases) {
            if (database) {
                if (database['is_nosql'] === false) {
                    this.databaseConnections.push(database);
                    this.databaseObjs.push(database['database_name']);
                }
            }
        }
        this.dataSource.data = this.database.initialData(this.databaseObjs, this.databaseConnections);
    }

    getSelectedDatabaseName() {
    }

    getSelectedDBConnectionName() {
    }

    getDatabasesForConnection(event) {
        this.tableName = '';
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.selectedDatabaseConnectionObject = this.databaseConnections.filter((element) => element['database_name'] === event['value']);
        this.confPost.getDatabasesForAConnection(this.partner, this.selectedDatabaseConnectionObject[0]['database_name'], this.selectedDatabaseConnectionObject[0]['database_type']).subscribe(response => {
            loaderDialog.close();
            if (response) {
                this.databases = response;
            } else {
                this.platform.openSnackBar('Error while fetching databases. Please try again after sometime.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            loaderDialog.close();
            this.platform.handleErrorGracefully(error, 'Error while fetching databases. Please try again after sometime.');
        });
    }

    getTablesForADatabase(event) {
        this.tableName = '';
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.getDatabaseTablesForAConnection(this.partner, this.selectedDatabaseConnectionObject[0]['database_name'], this.selectedDatabaseConnectionObject[0]['database_type'], event['value']).subscribe(response => {
            loaderDialog.close();
            if (response) {
                this.tables = response;
                this.refreshErDiagram();
            } else {
                this.platform.openSnackBar('Error while fetching tables. Please try again after sometime.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            loaderDialog.close();
            this.platform.handleErrorGracefully(error, 'Error while fetching tables. Please try again after sometime.');
        });
    }

    refreshErDiagram() {
        this.dataService.clearData();
        this.erTables = [];
        for (const table of this.tables) {
            this.confPost.getPropertiesOfTable(this.partner, this.selectedDatabaseConnectionObject[0]['database_type'], this.selectedDatabaseConnectionObject[0]['database_name'], this.databaseName, table).subscribe(response => {
                if (response) {
                    if (response.hasOwnProperty('columns')) {
                        const temp = {
                            tableName: table,
                            foreignKeys: response['foreignKeys'],
                            references: response['references'],
                            fields: response['columns']
                        };
                        if (response['foreignKeys'].length > 0 || response['references'].length > 0) {
                            this.relations.push(temp);
                        } else {
                            this.erTables.push(temp);
                        }
                    }
                }
            });
        }
    }

    loadDatabaseIntoTabs(dbName, dbConnectionName, selectedDbConnectionObject) {
        let databaseFound = false;
        this.selectedTables.forEach(tableObject => {
            if (tableObject) {
                if (tableObject['databaseName'] === dbName) {
                    if (tableObject['objectToRender'] === 'database') {
                        databaseFound = true;
                    }
                }
            }
        });
        if (databaseFound === false) {
            if (!this.selectedTables.length) {
                this.currentParentTab = dbName;
            }
            this.selectedTables.push({
                objectToRender: 'database',
                databaseConnectionName: dbConnectionName,
                databaseName: dbName,
                databaseERProperties: {
                    erTables: this.database.geterTables,
                    relations: this.database.getRelations
                },
                erDataLoading: this.database.getErDataLoadingStatus,
                selectedDatabaseConnectionObject: selectedDbConnectionObject
            });
        }
        this.selectedIndex = this.selectedTables.length;
    }

    loaddbObjectIntoTabs(itemName, dbConnectionName, dbName, selectedDbConnectionObject, dbType, resObj) {
        switch (dbType) {
            case 'database':
                this.loadDatabaseIntoTabs(itemName, dbConnectionName, selectedDbConnectionObject);
            case 'table':
                this.loadTablesIntoTabs(itemName, dbConnectionName, dbName, selectedDbConnectionObject);
                break;
            case 'view':
                this.loadViewsIntoTabs(itemName, dbConnectionName, dbName, selectedDbConnectionObject, resObj);
                break;
            default:
                this.loadObjsInTabs(itemName, resObj, selectedDbConnectionObject, dbType);
        }
    }

    loadViewsIntoTabs(viewName, dbConnectionName, dbName, selectedDbConnectionObject, resObj) {
        let viewFound = false;
        this.selectedTables.forEach(viewObject => {
            if (viewObject) {
                if (viewObject['tableName'] === viewName) {
                    viewFound = true;
                }
            }
        });
        if (viewFound === false) {
            if (!this.selectedTables.length) {
                this.currentParentTab = viewName;
            }
            this.selectedTables.push({
                objectToRender: 'view',
                databaseConnectionName: dbConnectionName,
                databaseName: dbName,
                tableName: viewName,
                viewObject: resObj,
                selectedDatabaseConnectionObject: selectedDbConnectionObject
            });
        }
        this.selectedIndex = this.selectedTables.length;
    }

    loadTablesIntoTabs(tableName, dbConnectionName, dbName, selectedDbConnectionObject) {
        let tableFound = false;
        this.selectedTables.forEach(tableObject => {
            if (tableObject) {
                if (tableObject['tableName'] === tableName) {
                    tableFound = true;
                }
            }
        });
        if (tableFound === false) {
            if (!this.selectedTables.length) {
                this.currentParentTab = tableName;
            }
            this.selectedTables.push({
                objectToRender: 'table',
                databaseConnectionName: dbConnectionName,
                databaseName: dbName,
                tableName: tableName,
                databaseERProperties: {
                    erTables: this.erTables,
                    relations: this.relations
                },
                selectedDatabaseConnectionObject: selectedDbConnectionObject,
                listOfTables: [tableName]
            });
        }
        this.selectedIndex = this.selectedTables.length;
    }

    loadObjsInTabs(itemName, resObj, selectedDbConnectionObject, dbObjType) {
        let itemFound = false;
        this.selectedTables.forEach(tableObject => {
            if (tableObject) {
                if (tableObject['tableName'] === itemName) {
                    itemFound = true;
                }
            }
        });
        if (itemFound === false) {
            if (!this.selectedTables.length) {
                this.currentParentTab = itemName;
            }
            this.selectedTables.push({
                objectToRender: dbObjType,
                tableName: itemName,
                dbObjType: dbObjType,
                resObj: resObj,
                selectedDatabaseConnectionObject: selectedDbConnectionObject
            });
        }
        this.selectedIndex = this.selectedTables.length;
    }

    parentTabChanged(currentTab) {
        if (this.selectedTables[currentTab.index].objectToRender === 'database') {
            this.currentParentTab = this.selectedTables[currentTab.index].databaseName;
        } else {
            this.currentParentTab = this.selectedTables[currentTab.index].tableName;
        }
        this.selectedIndex = currentTab.index;
    }

    closeTab(index) {
        if (index + 1 !== this.selectedTables.length) {
            if (this.selectedTables[index + 1].objectToRender === 'database') {
                this.currentParentTab = this.selectedTables[index + 1].databaseName;
            } else {
                this.currentParentTab = this.selectedTables[index + 1].tableName;
            }
        }

        this.selectedTables.splice(index, 1);
    }

    openNewConnectionsDialog() {
        const dialogRef = this.dialog.open(AddNewConnectionComponent, {
            panelClass: 'dialog-color',
            height: '85vh',
            width: '60vw',
            data: {fromDataCatalog: true}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.databasesResource.databasesDialogClosed(result, 'external');
        });
    }

    createPaddingRight() {
        document.getElementById('view:data_catalog').style.paddingRight = '400px';
    }

    removePaddingRight() {
        document.getElementById('view:data_catalog').style.paddingRight = '0px';
    }
}

@Component({
    selector: 'app-add-new-connection',
    templateUrl: 'add-new-connection.html',
    styleUrls: ['data-catalogue-parent.component.scss']
})

export class AddNewConnectionComponent {

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AddNewConnectionComponent>) {
    }
}
